import React, { useState } from "react";
import styled from "styled-components";
// import { sendEmail } from "./Form";
import SuccessModal from "./SuccessModal";
import { sendEmail } from "./AssociateForm";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFormSubmission = async (event) => {
    event.preventDefault();
    try {
      await sendEmail(event);
      setIsModalOpen(true);
      // Only React reset
      setFormData({
        name: "",
        email: "",
        mobile: "",
        segment: "",
        location: "",
        company_name: "",
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <FormWrapper onSubmit={handleFormSubmission}>
        <Row>
          <InputWrapper>
            <Input
              type="text"
              id="name"
              name="user_name"
              placeholder="Full Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
            />
          </InputWrapper>
          <InputWrapper>
            <Input
              type="email"
              id="email"
              name="user_email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              required
            />
          </InputWrapper>
        </Row>
        <TextareaWrapper>
          <TextArea
            id="message"
            name="message"
            placeholder="Write your message here..."
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
            required
          />
        </TextareaWrapper>
        <ButtonWrapper>
          <SubmitButton>Submit</SubmitButton>
        </ButtonWrapper>
      </FormWrapper>
      {isModalOpen && <SuccessModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

export default ContactForm;

const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const InputWrapper = styled.div`
  flex: 1;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
`;

const TextareaWrapper = styled.div``;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
  box-sizing: border-box;
`;

const SubmitButton = styled.button`
  width: 200px;
  padding: 12px;
  background-color: #005f73;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
`;
